import React from 'react';
import Layout from './src/components/layout';
import './src/styles/globals.css';

export const wrapPageElement = ({ element, props }) => {
  document.documentElement.setAttribute('lang', "en");
  document.documentElement.setAttribute('data-theme', localStorage.getItem("theme")?  localStorage.getItem("theme") : "github-dark");
  return <Layout {...props}>{element}</Layout>;
};